import React, { useEffect, useState } from 'react'
import { Moment } from 'moment'
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  ModalProps,
  Select,
  TextArea,
} from 'components/common'
import { noteRegExp, staticLedgerType } from 'lib/constants'
import { BookingSelectModal } from './BookingSelectModal'

export type AddLedgerValues = {
  date: Moment
  class: string
  amount: number
  note: string
  orderNumber: number
}

export type AllNumberOfPeopleAndOrderNumber = Array<{
  customer?: string
  orderNumber?: number
}>

export interface AddLedgerModalProps extends Omit<ModalProps, 'onOk'> {
  onOk?: (values: AddLedgerValues) => void
  date: Moment
  loading: boolean
}

const classOptions = Object.entries(staticLedgerType).map(([key, value]) => (
  <Select.Option key={key} value={key}>
    {value}
  </Select.Option>
))

export const AddLedgerModal = ({
  date,
  onCancel,
  visible,
  onOk,
  loading,
  ...rest
}: AddLedgerModalProps) => {
  const [form] = Form.useForm<AddLedgerValues>()
  // 選択された予約番号
  const [selectedOrderNumber, setSelectedOrderNumber] = useState<number>(null)

  useEffect(() => {
    form.setFieldsValue({
      date: date.clone(),
      class: '',
      amount: null,
      note: '',
    })
  }, [date, form])

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        onOk(values)
        form.resetFields()
        setSelectedOrderNumber(null)
      })
      .catch((error) => console.error(error))
  }

  return (
    <Modal
      title={<p className="text-4xl font-bold m-0">入出金を追加する</p>}
      visible={visible}
      onCancel={onCancel}
      confirmLoading={loading}
      width="60vw"
      style={{ maxWidth: '1200px' }}
      footer={
        <div className="flex justify-end m-2">
          <Button onClick={onCancel} style={{ marginRight: '16px' }}>
            キャンセル
          </Button>
          <Button type="primary" htmlType="submit" onClick={onSubmit}>
            追加
          </Button>
        </div>
      }
      {...rest}
    >
      <Form form={form} component="form">
        <div className="container">
          <div className="flex items-center justify-between">
            {/* 日付 */}
            <Form.Item
              name="date"
              label="日付"
              required
              rules={[{ required: true }]}
              initialValue={date}
              style={{ width: '30%' }}
            >
              <DatePicker allowClear value={date} style={{ width: '100%' }} />
            </Form.Item>

            {/* 区分 */}
            <Form.Item
              name="class"
              label="区分"
              required
              rules={[{ required: true }]}
              style={{ width: '30%' }}
            >
              <Select
                placeholder="区分を選択してください"
                style={{ width: '100%' }}
              >
                {classOptions}
              </Select>
            </Form.Item>

            {/* 金額 */}
            <Form.Item
              name="amount"
              label="金額"
              required
              rules={[{ required: true }]}
              style={{ width: '30%' }}
            >
              <Input type="number" prefix="￥" style={{ width: '100%' }} />
            </Form.Item>
          </div>

          {/* 対象の予約選択 */}
          <Form.Item label="対象の予約">
            <BookingSelectModal
              form={form}
              selectedOrderNumber={selectedOrderNumber}
              setSelectedOrderNumber={setSelectedOrderNumber}
            />
          </Form.Item>

          {/* 備考 */}
          <Form.Item
            name="note"
            label="備考"
            required
            rules={[
              {
                pattern: noteRegExp,
                message: '空白を含む項目は登録できません',
              },
              {
                max: 1024,
                message: '1024文字以内で入力してください',
              },
            ]}
          >
            <TextArea style={{ height: 150 }} />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}
